<template>
  <static-fullscreen-card :loaded="loaded">
    <template v-slot:title> ({{ data.id }}) {{ data.city }} {{ data.address }} [{{ statusCurrent.text }}{{ statusSite.text ? ", " + statusSite.text : "" }}] </template>
    <template v-slot:actions>
      <v-btn
        v-if="getAccess('agentObjects.redirect', { users: [data.user_id], data })"
        color="primary"
        :disabled="!loaded"
        @click="redirectUser"
        title="Переназначить пользователя"
      >
        <v-icon>fas fa-people-arrows</v-icon>
      </v-btn>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" v-bind="attrs" v-on="on" :disabled="!loaded">
            <v-icon>mdi-debug-step-over</v-icon>
            <btn-title>Статус</btn-title>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in statusItems" :key="index" link>
            <v-list-item-title @click="clickStatus(item)">
              {{ item.action }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <a-btn-edit v-if="getAccess(config.accessName + '.edit', id, data)" @click="showEditDialog = true" :disabled="!loaded" />
    </template>
    <portal to="v-main">
      <s-edit-form-async ref="editField" />
      <confirm-dialog ref="confirmDialog"></confirm-dialog>
      <DebugAvito ref="debugAvito"></DebugAvito>
      <edit-dialog v-if="showEditDialog" v-model="showEditDialog" :id="id" :api="url" :typeObject="objectType" :values="data"></edit-dialog>
    </portal>
    <v-row>
      <v-col cols="12" sm="6">
        <material-card color="secondary">
          <template v-slot:heading>
            <div class="px-3 py-1">фото объекта</div>
          </template>
          <a-view-images :value="data.photos" :style="{ height: blockHeight + 'px' }" />
        </material-card>
      </v-col>
      <v-col cols="12" sm="6">
        <material-card color="secondary">
          <template v-slot:heading>
            <div class="px-3 py-1">
              основная информация

              <v-btn v-if="data.data_avito" small color="primary" class="mr-2" dark @click="$refs.debugAvito.openAvito(data.data_avito)">
                <v-icon small left>mdi-storefront</v-icon>
                Авито
              </v-btn>
              <v-btn v-if="data.data_cian" small color="primary" dark @click="$refs.debugAvito.openCian(data.data_cian)">
                <v-icon small left>mdi-storefront</v-icon>
                циан
              </v-btn>
            </div>
          </template>
          <a-form-view :value="data" :model="modelRight" :config="{ dense: true, hideNull: true }" class="block_master" />
        </material-card>
      </v-col>
      <v-col cols="12">
        <material-card color="third">
          <template v-slot:heading>
            <v-tabs v-model="tab" background-color="transparent" slider-color="white">
              <v-tab v-for="(tab, i) in tabs" :key="i" class="mr-3">{{ tab.title }}</v-tab>
            </v-tabs>
          </template>
          <v-tabs-items v-model="tab" class="transparent" style="min-height: 200px" touchless>
            <v-tab-item>
              <v-card-text style="height: 300px; overflow: auto">
                <a-view-files :value="data.docs" />
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-col>
    </v-row>
    <div v-if="!loaded" class="loading-block">
      <div class="loader"></div>
    </div>
  </static-fullscreen-card>
</template>

<script>
import { statusChange, autoHeightBlock, getAccess, genModel, modelOptions, saveEl } from "../../components/mixings";
export default {
  mixins: [statusChange, autoHeightBlock, getAccess, genModel, modelOptions, saveEl],
  components: {
    editDialog: () => import("./../dialogs/objectsAgentDialog"),
    DebugAvito: () => import("./debugAvitoView"),
  },
  data() {
    return {
      id: 0,
      blockHeight: 250,
      showEditDialog: false,
      loading: !false,
      loaded: false,
      title: "",
      data: {},
      m: this.$store.getters["config/get"].models.objects,
      tab: 0,
      tabs: [{ title: "Документация" }],
      objectType: "",
    };
  },
  created() {
    this.objectType = this.$route.meta.objectType;
    this.$root.title = this.config.title;
    this.id = Number(this.$route.params.id);
    this.fitchData();
  },
  computed: {
    url() {
      return this.config.api;
    },
    statuses() {
      let res = [];
      res = this.getOptions({ options: "config.statuses.lamp_object,status_site" });
      return res;
    },
    statusCurrent() {
      let idx = this.statuses.findIndex((el) => {
        return el.value == this.data.status && el.field == "status";
      });
      if (idx == -1) return {};
      return JSON.parse(JSON.stringify(this.statuses[idx]));
    },
    statusSite() {
      let idx = this.statuses.findIndex((el) => {
        return el.value == this.data.status_site > 0 && el.field == "status_site";
      });
      if (idx == -1) return {};
      return JSON.parse(JSON.stringify(this.statuses[idx]));
    },
    statusItems() {
      let items = [];
      let res = [];
      let status = {};
      let type;
      type = "status";
      status = this.getStatus(type);
      if (status?.["next"]) {
        res = [
          ...res,
          ...this.statuses.filter((s) => {
            return status.next.includes(s.value) && s.field == type;
          }),
        ];
      }
      type = "status_site";
      status = this.getStatus(type);
      if (status?.["next"]) {
        res = [
          ...res,
          ...this.statuses.filter((s) => {
            return status.next.includes(s.value) && s.field == type;
          }),
        ];
      }

      items = JSON.parse(JSON.stringify(res));

      return items;
    },
    modelRight() {
      let model = this.calcModel(`config.${this.objectType}.viewForm2`);
      return model;
    },
    config() {
      return this.m?.config?.[this.objectType] || {};
    },
    model() {
      //let config = JSON.parse(JSON.stringify(this.m?.config?.considers || {}));
      let model = this.calcModelConfig(this.config);
      return model;
    },
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        this.fitchData();
      }
    },
  },
  methods: {
    async redirectUser() {
      let ok = await this.$refs.confirmDialog.show({
        title: "Переназначение",
        message: [`Вы действительно хотите изменить брокера ?`],
        okButton: "Да",
        cancelButton: "Нет",
      });
      if (!ok) return;
      let editField = {
        title: "Переназначить",
        data: { user_id: this.data.user_id },
        model: [{ name: "user_id", title: " Кому назначено", type: "select", dir: "user" }],
      };
      let res = await this.$refs.editField.show(editField);

      if (res) {
        res.id = this.id;
        await this.save(this.url, res);
        this.data.user_id = res.user_id;
      }
    },
    async fitchData() {
      this.loaded = false;
      const d = await this.$axios.get(this.url + "/" + this.id);
      if (d.data && d.data.data) {
        this.data = d.data.data;
        this.data.price_m2 = "";
        if (this.data.ap_area && this.data.ap_price_buy) {
          this.data.price_m2 = (this.data.ap_price_buy / this.data.ap_area).toFixed(2);
        }
      }
      this.loaded = true;
    },
  },
};
</script>
